import React, { createContext, useEffect, useState, useContext } from 'react';
import { useQuery } from 'react-query';
import { habitAPI, courseAPI } from '../api';
import formatBehaviorTitles from '../helpers/formatBehaviorTitles';
import useAuth from './AuthContext';

const DataContext = createContext();

export function DataProvider({ children }) {
  const { isLoggedIn, isLoading: authLoading } = useAuth();

  // Only fetch content data if user is authenticated
  const { data: contentData } = useQuery(
    'contentData',
    courseAPI.getContentData,
    {
      enabled: isLoggedIn,
      retry: false,
      staleTime: 5 * 60 * 1000,
    }
  );

  // Only fetch user habits if user is authenticated
  const { data: userHabits } = useQuery(
    'userHabits',
    habitAPI.getUserHabits,
    {
      enabled: isLoggedIn,
      retry: false,
      staleTime: 5 * 60 * 1000,
    }
  );

  if (contentData) {
    contentData.modules = formatBehaviorTitles(contentData?.modules)
  }

  const getLocalStorage = (key) => JSON.parse(localStorage.getItem(key));

  const [videoMap, setVideoMap] = useState(getLocalStorage('videoMap') || {});
  const [latestVideo, setLatestVideo] = useState(
    getLocalStorage('latestVideo') || {}
  );

  useEffect(() => {
    localStorage.setItem('videoMap', JSON.stringify(videoMap));
  }, [videoMap]);

  useEffect(() => {
    localStorage.setItem('latestVideo', JSON.stringify(latestVideo));
  }, [latestVideo]);

  return (
    <DataContext.Provider
      value={{
        contentData,
        userHabits,
        videoMap,
        setVideoMap,
        latestVideo,
        setLatestVideo
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

function useData() {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
}

export default useData;
